export const MPDParserErrorTypes = [
  "INVALID_NUMBER_OF_PERIOD",
  "INVALID_NUMBER_OF_CONTENT_STEERING",
  "DASH_EMPTY_MANIFEST",
  "DASH_INVALID_XML",
  "NO_BASE_URL",
  "MISSING_SEGMENT_INFORMATION",
  "SEGMENT_TIME_UNSPECIFIED",
  "UNSUPPORTED_UTC_TIMING_SCHEME",
];
